import { Alignment, Alignments } from '../schema/enum/alignments';
import { Size, Sizes } from '../schema/enum/sizes';

export class MediaContentGrid {
    public readonly gridColumns: number;
    public readonly gridRows: number;

    // image/video starting grid column
    public readonly mediaStartColumn: number;

    public readonly mediaColumns: number;
    
    // content/description ending grid column
    public readonly contentEndColumn: number;

    public readonly contentColumns: number;

    public readonly contentStartRow: number;


    constructor(mediaSize: Size, mediaAlignment: Alignment) {
        // column count based on standard tailwind grid
        this.gridColumns = 12;
        const isCenterAligned: boolean = mediaAlignment === Alignments.CENTER;
        const isRightAligned: boolean = mediaAlignment === Alignments.RIGHT;

        this.gridRows = isCenterAligned ? 2 : 1;
        this.contentStartRow = isCenterAligned ? 2 : 1;

        this.mediaColumns = 3;
        if (mediaSize === Sizes.MEDIUM) {
            this.mediaColumns = 6;
        } else if (mediaSize === Sizes.LARGE) {
            this.mediaColumns = 8;
        }

        // +1 used on center/right alignments because columns start counting at 1.
        // This means that with 12 columns the last column actually ends at 13
        this.mediaStartColumn = 1;
        if (isCenterAligned) {
            this.mediaStartColumn = Math.ceil((this.gridColumns - this.mediaColumns) / 2) + 1;
        } else if (isRightAligned) {
            this.mediaStartColumn = this.gridColumns - this.mediaColumns + 1;
        }

        // description goes below centered video/image, otherwise takes up remaining columns
        this.contentColumns = isCenterAligned ? this.gridColumns : this.gridColumns - this.mediaColumns;
        this.contentEndColumn = this.gridColumns + 1;
        if (isRightAligned) {
            // if video/image is right aligned, text takes up the remaining space to the left
            this.contentEndColumn = this.contentColumns + 1;
        }
    }
}
